import { Component, Vue, Prop } from 'vue-property-decorator'
import AreaApi from '@/api/area'
import { hasVisitor, debounce } from '@/utils/util'
const debounceSearch = debounce(300)

@Component({})
export default class HospitalMixin extends Vue {
	public form: any = {}
	public searchArea: any = []
	public areaData: any = ''
	public searchHospital: any = []
	public fetching = false
	public hasVisitor: any = hasVisitor

	/*就诊地区输入搜索*/
	public areaSearch(value: any) {
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				AreaApi.searchArea(value).then((res: any) => {
					if (res.data.length) {
						// this.noData = false
						this.searchArea = res.data.map((item: any) => {
							return {
								code: item.provCode + '-' + item.cityCode + '-' + item.areaCode,
								area: item.provName + '-' + item.cityName + '-' + item.areaName,
								cityName: item.cityName,
							}
						})
					} else {
						// this.noData = true
						this.searchArea = []
					}
					resolve()
				})
			})
		})
	}

	public onAreaSelect(res: any) {
		const code = res.code.split('-')
		this.areaData = {
			cityCode: code[1],
			areaCode: code[2],
		}
		this.searchHospital = []
	}

	public hospitalSearch(value: any) {
		if (!value) {
			return
		}
		return new Promise((resolve: any, reject: any) => {
			debounceSearch(() => {
				this.fetching = true
				AreaApi.hospitalTips({
					hospitalName: value,
					...this.areaData,
				})
					.then((res: any) => {
						if (!(res.data && res.data.length)) {
							this.searchHospital = []
							return
						}
						this.searchHospital = res.data.map((item: any) => {
							return {
								title: item.hospitalName,
								point: {
									lng: item.longitude,
									lat: item.latitude,
								},
								address: item.address,
							}
						})
						resolve()
					})
					.finally(() => {
						this.fetching = false
					})
			})
		})
	}

	public onHospitalSelect(res: any) {
		this.$nextTick(() => {
			this.form.setFieldsValue({
				hospital: {
					label: res.title,
					key: res.point.lng + '-' + res.point.lat,
				},
			})
		})
	}

	public created() {
		this.form = this.$form.createForm(this)
	}
}
